// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const ReceiptSearchIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "ReceiptSearch/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.15 1.667h-6.3c-3.15 0-3.933.841-3.933 4.2v9.383c0 2.217 1.216 2.742 2.691 1.158l.009-.008c.683-.725 1.725-.667 2.316.125l.842 1.125c.675.892 1.767.892 2.442 0l.841-1.125c.6-.8 1.642-.858 2.325-.125 1.484 1.583 2.692 1.058 2.692-1.158V5.867c.008-3.359-.775-4.2-3.925-4.2Zm-.1 10.441a.618.618 0 0 1-.442.184.618.618 0 0 1-.441-.184l-.617-.616A3.087 3.087 0 0 1 9.858 12a3.087 3.087 0 0 1-3.083-3.083c0-1.7 1.375-3.084 3.083-3.084a3.082 3.082 0 0 1 2.575 4.775l.617.617a.629.629 0 0 1 0 .883Z"
}));
export default ReceiptSearchIcon;